import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReducer from './devices-os-update-status.reducer';
import { OSUpdateStatus, DeviceOsUpdateStatusState } from './devices-os-update-status.state';
import { LocationsRouterStoreSelectors, DevicesRouterStoreSelectors } from '../router';

export const selectDevicesOsUpdateStatusesState = createFeatureSelector<DeviceOsUpdateStatusState>(
  fromReducer.DevicesOsUpdateStatesFeatureKey
);

export const selectDevicesOsUpdateStatuses = createSelector(
  selectDevicesOsUpdateStatusesState,
  fromReducer.selectDevicesOsUpdateStatuses
);

export const selectDevicesOsUpdateStatusesIds = createSelector(
  selectDevicesOsUpdateStatusesState,
  fromReducer.selectDevicesOsUpdateStatusesIds
);

export const selectDevicesOsUpdateStatusesEntities = createSelector(
  selectDevicesOsUpdateStatusesState,
  fromReducer.selectDevicesOsUpdateStatusesEntities
);

export const selectOsUpdateStatusesByLocationId = createSelector(
  selectDevicesOsUpdateStatuses,
  LocationsRouterStoreSelectors.selectLocationId,
  (status: OSUpdateStatus[], locationId: string) => status.filter((s) => s.locationId === locationId)
);

export const selectOsUpdateStatusByUdid = createSelector(
  selectDevicesOsUpdateStatusesState,
  DevicesRouterStoreSelectors.selectUdid,
  (state: DeviceOsUpdateStatusState, udid: string) => state.entities[udid]
);

export const selectOsUpdateStatusWithUdidParam = (udid: string) =>
  createSelector(selectDevicesOsUpdateStatusesState, (state: DeviceOsUpdateStatusState) => state.entities[udid]);
